import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    /**
     * Controlla che la stringa sia un numero di telefono in un formato ammesso:
     * cifre e separatori comuni (spazio, punto, trattino, slash, parentesi),
     * eventuale prefisso "+", da 6 a 30 caratteri.
     */
    phoneNumber(errorMessage?: string): StringSchema;
  }
}

// Telefono: cifre e separatori comuni, eventuale prefisso "+", da 6 a 30
// caratteri (tetto di formato generoso, non un limite di storage del DB).
const phoneNumberRegex = /^\+?[\d.\s()/-]{6,30}$/;

yup.addMethod(
  yup.string,
  'phoneNumber',
  function (this: yup.StringSchema, errorMessage?: string) {
    return this.test(
      'phoneNumber',
      errorMessage ?? 'Il numero di telefono non è in un formato valido',
      value => {
        // I campi opzionali vuoti restano validi: l'obbligatorietà è gestita a parte.
        if (!value) return true;
        return phoneNumberRegex.test(value);
      },
    );
  },
);
